import React from 'react';
import { Provider, observer } from 'mobx-react';

import Container from './Container';
import Logo from './Logo';
import Centered from './Centered';
import Details from './Details';
import Verified from './Verified';
import Verifying from './Verifying';
import Institution from './Institution';
import AccountNumber from './AccountNumber';
import EditPencil from './EditPencil';

export const bankAccountHeight = 8;

export default observer(({ bankAccount, onEdit, isBusy }) => (
  <Provider bankAccount={bankAccount}>
    <Container height={bankAccountHeight}>
      <Logo />
      <Details editor={!!onEdit} isBusy={isBusy}>
        <Centered>
          <Institution>{bankAccount.institution_name || 'Banking Institution'}</Institution>
          {bankAccount.account_name ? (
            bankAccount.account_name.match(/\.\.\./) ? (
              <AccountNumber>{bankAccount.account_name}</AccountNumber>
            ) : (
              <AccountNumber>
                {bankAccount.account_name} (...{bankAccount.number.slice(-4)})
              </AccountNumber>
            )
          ) : (
            <AccountNumber>Account: ...{bankAccount.number.slice(-4)}</AccountNumber>
          )}

          {bankAccount.is_verified ? <Verified /> : bankAccount.can_submit_verification ? <Verifying /> : null}
        </Centered>
        {onEdit && <EditPencil onClick={onEdit} isBusy={isBusy} />}
      </Details>
    </Container>
  </Provider>
));
